import { Module } from 'vuex';
import { IRootState } from '@/store';
import { ITariffState } from './tariff.types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { TariffTypeEnum } from '@/models';

export const state: ITariffState = {
  tariffs: [],
  version: 1,
  lastPromise: null,
  tariffTypeVisuals: [
    {
      value: TariffTypeEnum.Country,
      text: 'Country'
    },
    {
      value: TariffTypeEnum.Region,
      text: 'Region'
    },
    {
      value: TariffTypeEnum.HSCode,
      text: 'HS Code'
    }
  ]
};

const namespaced = true;

export const tariff: Module<ITariffState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
